(function () {
  var root = document.querySelector('.clg-sidebar-layout');
  if (!root) return;
  var links = root.querySelectorAll('[data-clg-cat-link]');
  var defaultContent = root.querySelector('[data-clg-default-content]');
  var productGrid = root.querySelector('[data-clg-product-grid]');
  var searchInput = root.querySelector('[data-clg-search]');
  var catItems = root.querySelectorAll('[data-clg-cat-item]');
  var searchEmpty = root.querySelector('[data-clg-search-empty]');
  var shopCurrency = root.getAttribute('data-currency') || 'USD';
  var textNoProducts = 'No products found in this collection.';
  var textLoading = 'Loading...';
  var textError = 'Something went wrong.';

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim().toLowerCase();
      var visibleCount = 0;
      catItems.forEach(function (item) {
        var text = item.getAttribute('data-clg-search-text') || '';
        var matches = text.indexOf(query) !== -1;
        item.hidden = !matches;
        if (matches) visibleCount++;
      });
      if (searchEmpty) searchEmpty.hidden = visibleCount > 0;
    });
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: shopCurrency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function renderProducts(products) {
    if (!products.length) {
      productGrid.innerHTML = '<div class="clg-product-empty">' + textNoProducts + '</div>';
      return;
    }
    productGrid.innerHTML = products
      .map(function (product) {
        var variant = product.variants[0];
        var hasDiscount = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);
        var imageSrc = '';
        if (product.images && product.images.length) {
          imageSrc = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
        } else if (product.featured_image) {
          imageSrc = product.featured_image;
        }
        var productUrl = product.url || ('/products/' + product.handle);
        return (
          '<a href="' + productUrl + '" class="clg-product-card">' +
            '<img src="' + imageSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="400">' +
            '<p class="clg-product-title">' + product.title + '</p>' +
            '<span class="clg-product-price">' + formatMoney(variant.price * 100) + '</span>' +
            (hasDiscount ? '<span class="clg-product-compare">' + formatMoney(variant.compare_at_price * 100) + '</span>' : '') +
          '</a>'
        );
      })
      .join('');
  }

  function loadCollection(handle) {
    defaultContent.hidden = true;
    productGrid.hidden = false;
    productGrid.innerHTML = '<div class="clg-product-empty">' + textLoading + '</div>';

    fetch('/collections/' + handle + '/products.json?limit=24')
      .then(function (response) { return response.json(); })
      .then(function (data) { renderProducts(data.products || []); })
      .catch(function () {
        productGrid.innerHTML = '<div class="clg-product-empty">' + textError + '</div>';
      });
  }

  links.forEach(function (link) {
    link.addEventListener('click', function () {
      links.forEach(function (l) { l.classList.remove('clg-cat-active'); });
      link.classList.add('clg-cat-active');
      loadCollection(link.getAttribute('data-collection-handle'));
    });
  });
})();
